$('div[popoverButton]').click(function () {
    var id = $(this).attr('popoverButton');
    if ($('.popup--content[popoverContent="' + id + '"]').is(':visible')) {
        $('.popup--content[popoverContent="' + id + '"]').fadeOut();
        $(this).removeClass('active');
    } else {
        $('.popup--content[popoverContent="' + id + '"]').fadeIn();
        $('.popup--content:not([popoverContent="' + id + '"])').fadeOut();
        $(this).addClass('active');
    }


});

$(document).mouseup(function (e) {
    var container = $('.popup--content');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.popup--content').fadeOut();
        $('div[popoverButton]').removeClass('active');
        $('.popup--content[hoverConten]').hide().css('display', 'none');
        //$('.schritt--wrapper, .schritte-control').removeClass('active');
    }
});
/**
 * Flex Schritte Hover handler
 */

$('div[hoverButton]').on('mouseenter', function () {
    //$('.schritte-control').addClass('active');
    var id = $(this).attr('hoverButton');
    $('.popup--content[hoverContent="' + id + '"]').fadeIn().css('display', 'grid');
    $('.popup--content:not([hoverContent="' + id + '"])').hide();
    //$('.schritt--wrapper').removeClass('active');
    $(this).addClass('active');
});


$('.copy--link--themen').click(function (e) {
    e.preventDefault();
    var copytext = $(this).attr('href');
    console.log(copytext);
    navigator.clipboard.writeText(copytext);

    return false;
});
// copy current url to clipboard (blog single)
function copyLink() {
    var copyText = window.location.href;
    navigator.clipboard.writeText(copyText);
}
$('.copy--link').click(function (e) {
    e.preventDefault();
    copyLink();
    return false;
});

document.querySelectorAll('.table-header-mobile').forEach(element => {
    const title = element.getAttribute('data-title').replace(/<br>/g, '\n');
    element.setAttribute('data-title', title);
});

  
